/* eslint-disable react/no-danger */
import React from 'react';
import { elementType, string } from 'prop-types';
import { sanitizeHtml } from '../../util/sanitizeHtml';

/**
 * Renders stored rich text (descriptions, bios, messages) as HTML after
 * sanitizing it. Use this instead of dangerouslySetInnerHTML for anything
 * users can write: the data can reach Sharetribe without passing through our
 * editor, so it can't be trusted as-is.
 */
const SafeHtml = ({ as: Tag, html, ...rest }) => (
  <Tag {...rest} dangerouslySetInnerHTML={{ __html: sanitizeHtml(html) }} />
);

SafeHtml.defaultProps = {
  as: 'div',
  html: null,
};

SafeHtml.propTypes = {
  as: elementType,
  html: string,
};

export default SafeHtml;
